<div class="animated fadeIn">
<h3>Analyst Panel</h3>
<br/>

<!--  Traffic  -->
<div class="row">
<div class="col-lg-12">
<div class="card">
<div class="card-body" style="min-height: 600px;">
<h4 class="box-title">Dashboard</h4>

<img src="./assets/images/dashboard.jpg" alt="" class="img-fluid">
</div>
</div>
</div><!-- /# column -->
</div>
<!--  /Traffic -->
<div class="clearfix"></div>
</div>
